<template>
  <tr class="plc-tableRow">
    <td data-th="Rank" class="plc-tableRow__cell">
      {{ row.rank }}
    </td>
    <td data-th="Address" class="plc-tableRow__cell">
      <router-link
        :to="{ name: 'Address', params: { id: row.address } }"
        class="text-link text-truncate"
        >{{ row.address }}</router-link
      >
    </td>
    <td data-th="Quantity" class="plc-tableRow__cell">
      <span class="text--green text--bold text-truncate">{{ row.quantity }}</span>
    </td>
    <td data-th="Percentage" class="plc-tableRow__cell">
      <span class="text--light text-truncate">{{ row.percentage }}</span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'HoldersTableRow',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/tableRow';
</style>
